import { captureException } from '@/lib/errors'
import { useMutation } from '@/lib/mutations'
import { offlineExecutor } from '@/lib/offline'
import { useStore } from '@/lib/pocketbase'

interface UpdateActiveEntryData {
    entryId: string
    clock_in: string
    notes?: string
}

export function useUpdateActiveEntry() {
    const [timeEntriesCollection] = useStore('time_entries')

    const mutation = useMutation({
        networkMode: 'always',
        mutationFn: async (data: UpdateActiveEntryData) => {
            const { entryId, ...updateData } = data

            const tx = offlineExecutor.createOfflineTransaction({
                mutationFnName: 'syncTimeEntries',
            })
            tx.mutate(() => {
                timeEntriesCollection.update(entryId, draft => {
                    draft.clock_in = updateData.clock_in
                    draft.notes = updateData.notes ?? ''
                })
            })
        },
        onError: error => {
            captureException('Update active entry failed', error)
        },
    })

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
    }
}
